import IAuthentication from "../../../models/authentication/IAuthentication";

const newAuthentication = (): IAuthentication => ({
    emailAddress: "",
    displayName: ""
});

export default newAuthentication;